angular.module('festzelt-os.modules.templates', [
    'festzelt-os.components'
]);

require('./routes');

require('./components/al-template-guestlists/component');
require('./components/al-beefree-editor/component');
require('./components/al-email-template-editor/component');

require('./factories/template-factory');
require('./store/templates');

require('./workflows/workflows');



// WEBPACK FOOTER //
// ./src/app/modules/templates/module.js